import { getFullNameOrEmail } from "@utils/tags.util";
import { IMemberTagResponse } from "@interfaces/responses.interface";
import { CompanyAvatar, CompanyAvatarSizes } from "@ui/Avatars/CompanyAvatar";
import { TagWrapper } from "./TagWrapper";
import { TagLabel } from "@ui/Content";
import { View } from "@ui/View";

interface Props {
  data: IMemberTagResponse;
  isDisabled: boolean;
  onAdd?: (tag: IMemberTagResponse) => void;
  onRemove?: (tag: IMemberTagResponse) => void;
  withPlusIcon?: boolean;
  iconOnly?: boolean;
}

export function MemberTag({ data, isDisabled, onAdd, onRemove, withPlusIcon, iconOnly }: Props) {
  const displayName = getFullNameOrEmail(data.object);

  return (
    <TagWrapper
      data={data}
      isDisabled={isDisabled}
      onRemove={onRemove}
      withPlusIcon={withPlusIcon}
      onAdd={onAdd}
      isMemberTag
    >
      <CompanyAvatar
        classNames="rounded-full border flex-shrink-0 w-5 h-5"
        size={CompanyAvatarSizes.SMALL}
        userProps={{
          first_name: data.object.first_name,
          last_name: data.object.last_name,
          email: data.object.email,
        }}
        logoUrl={data.object.avatar_url}
      />

      <View.Condition if={!iconOnly}>
        <TagLabel className="mr-1">{displayName}</TagLabel>
      </View.Condition>
    </TagWrapper>
  );
}
